import request from '@/utils/request'

export function signupSmartTechUp(email, password, companyname, appInterested, ciInterested) {
  return request({
    url: '/auth/local/register',
    method: 'post',
    data: {
      email: email,
      password: password,
      feature: 'sfera',
      role: 'User',
      companyname: companyname,
      appInterested: appInterested,
      ciInterested: ciInterested
    }
  })
}

export function registerSmartTechUp() {
  return request({
    url: '/sfera/user/register',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/signup.js